import { transformConstants } from '../helpers';

const pageEventConstants = transformConstants([
  'MOKAPOS_INGREDIENT_PAGE',
  'MOKAPOS_INVENTORY_TRANSFER_START',
  'MOKAPOS_DASHBOARD_PAGE',
  'MOKAPOS_PAYMENT_CONFIGURATION_PAGE',
  'MOKAPOS_INGREDIENT_LIBRARY_PAGE',
  'MOKAPOS_REGISTRATION_START',
  'MOKAPOS_REGISTRATION_BUSINESS_INFORMATION',
  'MOKAPOS_SETTING_BILLING_START',
  'MOKAPOS_LIBRARY_MODIFIER_START',
  'MOKAPOS_LIBRARY_ITEM_START',

  // REPORT
  'MOKAPOS_REPORT_DISCOUNT_PAGE',
  'MOKAPOS_REPORT_COLLECTED_PAGE',
  'MOKAPOS_REPORT_CATEGORY_SALES_PAGE',
  'MOKAPOS_REPORT_SUMMARY_START',
  'MOKAPOS_REPORT_PAYMENT_METHODS_START',
  'MOKAPOS_REPORT_SALES_TYPE_START',
  'MOKAPOS_REPORT_ITEM_SALES_START',
  'MOKAPOS_REPORT_MODIFIER_SALES_START',
  'MOKAPOS_REPORT_TAX_START',
  'MOKAPOS_REPORT_GRATUITY_START',
  'MOKAPOS_REPORT_SERVED_START',
  'MOKAPOS_REPORT_TRANSACTIONS_START',
  'MOKAPOS_REPORT_INVOICE_START',
  'MOKAPOS_REPORT_SHIFT_START',
]);

export { pageEventConstants };
